// Pure helpers for the Edit Field "Meteorological Data" station list.
// Kept dependency-free (no React / webpack aliases) so they can be unit-tested
// in isolation with `node --test`.
//
// The list being edited is geo_data.meteorological_stations: internal station
// IDs as strings. Its order is the priority the backend reads the stations in,
// and it may hold the same ID more than once.

// Append a station ID (as a string) unless it is already listed.
const addStation = (stationIds, stationId) => {
  const current = stationIds || [];
  const id = String(stationId);
  if (current.map(String).includes(id)) return [...current];
  return [...current, id];
};

// Remove the entry at `index`. By index rather than by ID, so that one of two
// duplicate entries can be removed on its own.
const removeStationAt = (stationIds, index) => {
  const current = stationIds || [];
  return current.filter((_, i) => i !== index);
};

// One display row per listed ID, in order.
//
//   availableStations     - the station catalogue ({ id, name }), or
//                           undefined/null while it is still loading
//   meteorologicalSources - station names the backend sent with the field
//                           (geo_data.meteorological_sources); they describe
//                           the SAVED list, so they are only a fallback label
//                           while the catalogue loads, and only when they line
//                           up one-to-one with the IDs
const buildStationRows = (
  stationIds,
  availableStations,
  meteorologicalSources,
) => {
  const ids = stationIds || [];
  const sources = meteorologicalSources || [];
  const useSources = !availableStations && sources.length === ids.length;

  return ids.map((stationId, index) => {
    const id = String(stationId);
    const station = (availableStations || []).find((s) => String(s.id) === id);
    const label = (station && station.name) || (useSources && sources[index]);
    return { id, index, label: label || id };
  });
};

module.exports = { addStation, removeStationAt, buildStationRows };
